import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { closePopup } from "../actions/popup"

function Popup({ popup, closePopup }) {
  if (popup.display) {
    document.querySelector('.menu-shadow').style.display = 'none';
    document.querySelector('.mob-menu').classList.remove('open');
    document.querySelector('.wrap-menu').classList.remove('open');
  }
  return (
    <div className={`auth-popup ${popup.name === 'Регистрация' || popup.name === 'Редактирование профиля'  || popup.name === 'Связь с администратором' ? 'long' : ''}`}>
      {
        popup.display &&
        <Fragment>
          <div className="auth-popup-name">{popup.name}</div>
          <svg onClick={() => { closePopup() }} className="auth-popup-close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 7L17 17" stroke="#E2E8F0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M17 7L7 17" stroke="#E2E8F0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <div className="auth-popup-content">{popup.content}</div>
        </Fragment>
      }
    </div>
  )
}

const mapStateToProps = state => ({
  popup: state.popup
})

export default connect(mapStateToProps, { closePopup })(Popup)